$(window).on('load', function () {

});

$(document).on('click', '.metaproducts_ele .variant-input', function(event) {
    var vl = $(this).attr('data-value');
    $('.arne-color-swatch-element').removeClass('disabled_div');
    $('.arne-color-swatch-element').each(function() {
      var x = JSON.parse($(this).find('script').html());
      var that = $(this);
      var vav = false;
    
      var hr = that.attr('rel_handle');
      x.forEach(function(v, i) {
        if (v.option1 == vl || v.option2 == vl || v.option3 == vl) {
          if (v.available) {} else {
            that.addClass('disabled_div');
          }
          vav = true;
          if (that.hasClass('active')) {} else {
            var hrl = hr+'?variant='+v.id;

            if (vl == v.title) {
              that.find('a').attr('href', hrl);
            }
          }
        }
      });
      if (vav) {
      } else {
        that.addClass('disabled_div');
      }
    });
});

$(document).ready(function() {
  $(document).on("change",".custom_complentary_product_select",function(){
    var v = $(this).val();
    $(this).parents('.select_cst_btn').find('input[name="id"]').val(v);
  })
  $('summary.menu-drawer__menu-item').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
  });
  
  $(document).on('click', '.customer a[href="#recover"]', function() {
    $('.log').hide();
    $('.rec').show();
  });

  $(document).on('click', '.customer a[href="#login"]', function() {
    $('.log').show();
    $('.rec').hide();
  });
  
  // $(document).on('click', '.personal_info_show', function() {
  //   $('.customer_order_and_info .customer_info').show();
  //   $('.customer_orders').hide();
  //   $('.cst_accounts-tab li').removeClass('active');
  //   $(this).addClass('active');
  // });
  
  // $(document).on('click', '.orders_info_show', function() {
  //   $('.customer_order_and_info .customer_info').hide();
  //   $('.customer_orders').show();
  //   $('.cst_accounts-tab li').removeClass('active');
  //   $(this).addClass('active');
  // });
  
  $('.togglepassword').click(function() {
    $(this).toggleClass('active');  
    var iptype = $(this).siblings('input').attr('type');
    if (iptype == 'password') {
      $(this).siblings('input').attr('type', 'text');
    } else {
      $(this).siblings('input').attr('type', 'password');
    }
  });
  
  $(".handle-collapse-model-wears a").click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    var index = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $('li[data-media-index="'+index+'"]').offset().top - 70
    }, 1000);
    var i = $('li[data-media-index="'+index+'"]').position();
    $('.product__media-list.contains-media').scrollLeft(i.left);
  });
  
  $('.list-social__link span').removeClass('visually-hidden');
  $('.list-social__link svg').hide();
  
  $('.maebe-faq .accordion').click(function() {
    $(this).toggleClass('active');
    $(this).next().slideToggle();
  });

    $(document).on('click', '.modal-toggle', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
  });
  $(window).on("resize", function (e) {
    checkScreenSize();
  });
  
  checkScreenSize();
  
  function checkScreenSize(){
    var newWindowWidth = $(window).width();
    if (newWindowWidth < 768) {
    }
  }
  
  $('button.closenewsletter').click(function() {
    $('.newletter_wrp_popup').hide();
  });
  
  $('.slider--desktop_ele.owl-carousel').owlCarousel({
    loop: false,
    responsiveClass: true,
    autoplay: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 50
      },
      600: {
        items: 4
      }
    },
    nav: true,
    margin: 4,
    dots: false
  });
  $('.slider--desktop_ele.owl-carousel .owl-prev').html('<p class="dflexarrows"><span>←</span><span>Back</span></p>');
  $('.slider--desktop_ele.owl-carousel .owl-next').html('<p class="dflexarrows"><span>Next</span><span>→</span></p>');


  $('form#customer_login button').click(function(e) {
    e.preventDefault();
    var em = $(this).parents('form').find('input#CustomerEmail').val();
    var pas = $(this).parents('form').find('input#CustomerPassword').val();
    if (em == '') {
      $(this).parents('form').find('input#CustomerEmail').addClass('error');
      setTimeout(() => {        
        $(this).parents('form').find('input#CustomerEmail').removeClass('error');
      },500);
      return;
    }
    
    $(this).parents('form').find('input#CustomerEmail').removeClass('error');
    if (pas == '') {      
      $(this).parents('form').find('input#CustomerPassword').addClass('error');
      setTimeout(() => {        
        $(this).parents('form').find('input#CustomerEmail').removeClass('error');
        $(this).parents('form').find('input#CustomerPassword').removeClass('error');
      },500);
      return;
    }
    $(this).parents('form#customer_login').submit();
  });
  
    var choices = document.querySelectorAll('.product-form__input--pill input[type=radio]+label');
    var maxWidth = 0;
    // read
    for (var i = 0; i < choices.length; ++i) {
        maxWidth = Math.max(maxWidth, choices[i].offsetWidth)
    };
    
    // write
    for (var i = 0; i < choices.length; ++i) {
        choices[i].style.width = maxWidth + "px";
    };   
});
document.querySelectorAll('.quick-add-button-trigger').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // FIND ONLY THE DRAWER INSIDE THIS SPECIFIC CARD
    const currentCard = btn.closest('.card__inner');
    const drawer = currentCard.querySelector('.quick-add-drawer');
    
    // Close any other open drawers first (Optional but cleaner)
    document.querySelectorAll('.quick-add-drawer.is-active').forEach(openDrawer => {
      openDrawer.classList.remove('is-active');
    });

    drawer.classList.add('is-active');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const initQuickAdd = () => {
    document.querySelectorAll('.quick-add-wrapper').forEach(wrapper => {
      const productId = wrapper.dataset.productId;
      const jsonElement = document.getElementById(`Variants-${productId}`);
      if (!jsonElement) return;

      const variants = JSON.parse(jsonElement.textContent);
      const drawer = wrapper.querySelector('.quick-add-drawer');
      const addBtn = wrapper.querySelector('.add-to-basket-btn');
      const optionGrids = wrapper.querySelectorAll('.option-grid');
      let selections = {};

      // Open Drawer
      wrapper.querySelector('.quick-add-button-trigger')?.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        drawer.classList.add('is-active');
      });

      // Close Drawer
      wrapper.querySelector('.quick-add-close')?.addEventListener('click', (e) => {
        e.stopPropagation();
        drawer.classList.remove('is-active');
      });

      // Handle Clicks on Sizes/Colors
      wrapper.querySelectorAll('.opt-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          if (btn.classList.contains('sold-out')) return;

          const grid = btn.closest('.option-grid');
          const optionIndex = grid.dataset.index;
          const val = btn.dataset.value.trim().toLowerCase();

          grid.querySelectorAll('.opt-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          selections[optionIndex] = val;
          updateButtonState();
        });
      });

      function updateButtonState() {
        const totalReq = optionGrids.length;
        if (Object.keys(selections).length === totalReq) {
          const variant = variants.find(v => {
            return Object.keys(selections).every(key => {
              return v[key] && v[key].toString().trim().toLowerCase() === selections[key];
            });
          });

          if (variant && variant.available) {
            addBtn.disabled = false;
            addBtn.dataset.variantId = variant.id;
            addBtn.querySelector('.btn-text').textContent = "ADD TO BASKET";
          } else {
            addBtn.disabled = true;
            addBtn.querySelector('.btn-text').textContent = "SOLD OUT";
          }
        }
      }

addBtn.addEventListener('click', async (e) => {
  e.stopPropagation();
  const variantId = addBtn.dataset.variantId;
  addBtn.classList.add('loading');
  
  const body = JSON.stringify({
    id: variantId,
    quantity: 1,
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  });

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    });

    const cartData = await response.json();

    if (response.ok) {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        // 1. Update the HTML contents
        cartDrawer.renderContents(cartData);

        // 2. FIX: Remove the 'empty' classes so the cart actually shows
        cartDrawer.classList.remove('is-empty', 'empty');
        
        // 3. Update the Cart Icon Bubble
        if (cartData.sections['cart-icon-bubble']) {
          const iconBubble = document.getElementById('cart-icon-bubble');
          if (iconBubble) iconBubble.innerHTML = cartData.sections['cart-icon-bubble'];
        }

        // 4. Open the drawer with a small delay to avoid the focus-trap error
        setTimeout(() => {
          cartDrawer.open();
        }, 100);
      }
      
      drawer.classList.remove('is-active');
    }
  } catch (error) {
    console.error("Quick Add Error:", error);
  } finally {
    addBtn.classList.remove('loading');
  }
});
      

    });
  };

  initQuickAdd();
});
